import { Action } from '@ngrx/store';

export const SET_LEGAL_ENTITY_STATUS = '[CustomUser] Set Legal Entity Status';

export class SetLegalEntityStatus implements Action {
  readonly type = SET_LEGAL_ENTITY_STATUS;

  constructor(public payload: boolean) {}
}

export type LegalEntityStatusActions = SetLegalEntityStatus;
